import find from 'lodash/find';

export default function getUserOrgByUserId(state, id) {
  return find(state.orgUsers.users, user => user.userId === Number.parseInt(id));
}
